<template>
    <div class="container">
        <div style="position: relative">
            <section-title style="margin-top: 20px;"></section-title>
            <budget-mobile-open style="font-size: 1.5em"></budget-mobile-open>
        </div>
        <div class="custom-block">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import BudgetMobileOpen from "./BudgetMobileOpen";
    export default {
        name: "CustomContainerMain",
        components: {BudgetMobileOpen}
    }
</script>

<style scoped>
    @media (min-width: 992px) {
        .custom-block {
            color: #1a1a1a;
            background-color: #f3f3f3;
            padding: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }

</style>

<style>
    .custom-block .block-content {
        background-color: white;
    }
</style>
